export const getIsInitiallyVisible = (
  numberOfVisibleCards: number,
  index: number,
  peekPercentage?: number
) =>
  index + (peekPercentage !== undefined && peekPercentage >= 80 ? 0 : 1) <=
  numberOfVisibleCards
    ? "yes"
    : "no";
